export default __webpack_public_path__ + "media/images/corporate/hero/md-c8ae082f80d2122a874bf488f9ad45ab.webp";